import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/Main.vue'
// import Registration from '@/pages/Registration.vue'
import RegistrationFree from '@/pages/RegistrationFree.vue'
import PageNotFound from '@/pages/PageNotFound.vue'
// import SearchEstate from '@/pages/SearchEstate.vue'
import ViewEstate from '@/pages/ViewEstate.vue'
import Login from '@/pages/Login.vue'
import ViewNotice from '@/pages/ViewNotice.vue'
import ViewReference from '@/pages/ViewReference.vue'
import ViewQuestion from '@/pages/ViewQuestion.vue'
import RecommendedItems from '@/admin/RecommendedItems.vue'
import ExpertManagement from '@/admin/ExpertManagement.vue'
import AdminNotice from '@/admin/AdminNotice.vue'
import AdminReference from '@/admin/AdminReference.vue'
import AdminBanner from '@/admin/AdminBanner.vue'
import AdminQna from '@/admin/AdminQna.vue'
import MyPage from '@/pages/MyPage.vue'
import MyTestPage from '@/pages/MyPageTest.vue'
import AdminLogin from '@/admin/AdminLogin.vue'
import AdminRegEstate from '@/admin/AdminRegEstate.vue'
import AdminEstate from '@/admin/AdminEstate.vue'
import AdminDocItem from '@/admin/AdminDocItem.vue'
import AdminUser from '@/admin/AdminUser.vue'

Vue.use(Router)

const body = document.getElementsByTagName('body')[0]

const requireMemberAuth = () => (to, from, next) => {
  if (sessionStorage.getItem('token') != null) {
    return next()
  }
  alert('세션 만료 또는 잘못된 접근 입니다.')
  next('/Login')
}

const requireAdminAuth = () => (to, from, next) => {
  if (sessionStorage.getItem('token') != null) {
    return next()
  }
  alert('세션 만료 또는 잘못된 접근 입니다.')
  next('/Adminlogin')
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/Registration',
      name: 'Registration',
      component: RegistrationFree,
      // 중첩된 라우트는 children 속성으로 하위 라우트를 정의할 수 있다.
      children: [
        { path: 'success', component: { template: '<div></div>' } },
        { path: 'fail', component: { template: '<div></div>' } }
      ],
      beforeEnter: requireMemberAuth()
    },
    /*    {
      path: '/SearchEstate',
      name: 'SearchEstate',
      component: SearchEstate
    }, */
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/ViewEstate/:id?',
      name: 'ViewEstate',
      component: ViewEstate
    },
    {
      path: '/ViewNotice/:id?',
      name: 'ViewNotice',
      component: ViewNotice
    },
    {
      path: '/ViewReference/:id?',
      name: 'ViewReference',
      component: ViewReference,
      children: [
        { path: 'success', component: { template: '<div></div>' } },
        { path: 'fail', component: { template: '<div></div>' } }
      ]
    },
    {
      path: '/ViewQuestion',
      name: 'ViewQuestion',
      component: ViewQuestion
    },
    {
      path: '/RecommendedItems',
      name: 'RecommendedItems',
      component: RecommendedItems,
      beforeEnter: requireAdminAuth()
    },
    {
      path: '/ExpertManagement',
      name: 'ExpertManagement',
      component: ExpertManagement,
      beforeEnter: requireAdminAuth()
    },
    {
      path: '/AdminNotice',
      name: 'AdminNotice',
      component: AdminNotice,
      beforeEnter: requireAdminAuth()
    },
    {
      path: '/AdminReference',
      name: 'AdminReference',
      component: AdminReference,
      beforeEnter: requireAdminAuth()
    },
    {
      path: '/AdminBanner',
      name: 'AdminBanner',
      component: AdminBanner,
      beforeEnter: requireAdminAuth()
    },
    {
      path: '/Mypage',
      name: 'Mypage',
      component: MyPage,
      beforeEnter: requireMemberAuth()
    },
    {
      path: '/MyTestPage',
      name: 'MyTestPage',
      component: MyTestPage
    },
    {
      path: '/AdminQna',
      name: 'AdminQna',
      component: AdminQna,
      beforeEnter: requireAdminAuth()
    },
    {
      path: '/AdminLogin',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/AdminRegEstate/:id?',
      name: 'AdminRegEstate',
      component: AdminRegEstate,
      beforeEnter: requireAdminAuth()
    },
    {
      path: '/AdminEstate',
      name: 'AdminEstate',
      component: AdminEstate,
      beforeEnter: requireAdminAuth()
    },
    {
      path: '/AdminDocItem',
      name: 'AdminDocItem',
      component: AdminDocItem,
      beforeEnter: requireAdminAuth()
    },
    {
      path: '/AdminUser',
      name: 'AdminUser',
      component: AdminUser,
      beforeEnter: requireAdminAuth()
    },
    {
      path: '*',
      component: PageNotFound
    }
  ],
  scrollBehavior (to, from) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 0)
      body.classList.remove('overflow')
    })
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js